import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocationRelatedDTO } from '../../../../models/LocationRelatedDTO';
import { GetRelatedByIdentifierResponse } from '../../../../models/GetLocationRelatedResponse';
import { firstValueFrom, Subscription } from 'rxjs';
import {MapHelperService } from '../../../../../../../services/map-helper.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { LocationRelatedService } from 'src/app/features/locations-map/services/LocationRelated.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { VirtualLocationsService } from 'src/app/features/locations-map/services/VirtualLocations.service';
@Component({
  selector: 'location-related-list',
  templateUrl: './location-related-list.component.html',
  styleUrls: ['./location-related-list.component.css']
})
export class LocationRelatedListComponent {
  @Input() identifier : string = "";
  @Input() childCategory : number = 0;
  @Input() includeRoute : boolean = false;

  locationRelatedListResponse: string = "Cargando...";
  globalFinder: string = "";

  getRelatedByIdentifierResponse: GetRelatedByIdentifierResponse;
  originalShownLocationRelatedList: LocationRelatedDTO[] = [];
  shownLocationRelatedList: LocationRelatedDTO[] = [];
  itemList: LocationRelatedDTO[] = [];
  itemsListPivot: LocationRelatedDTO[] = [];

  suscription_getDataKeyNames: Subscription;
  suscription_getImages: Subscription;
  suscription_updateLocationsRelated: Subscription;

  constructor(
    private dialog: MatDialog,
    public locationRelatedService: LocationRelatedService,
    public virtualLocationsService: VirtualLocationsService,
    private notifyService: SwalNotificationService,
    private mapHelperService: MapHelperService,
  ) {}

  ngOnInit(): void {
    this.getLocationsRelated();
  }
  
  suscription_getLocationRelatedList: Subscription;
  subscription_GetAllRelatedFilteredList: Subscription;

  ngOnDestroy() {
    if (this.suscription_getLocationRelatedList)
      this.suscription_getLocationRelatedList.unsubscribe();
    if (this.subscription_GetAllRelatedFilteredList)
      this.subscription_GetAllRelatedFilteredList.unsubscribe();
    if (this.suscription_updateLocationsRelated)
      this.suscription_updateLocationsRelated.unsubscribe();

    if(this.locationRelatedService.dialogDetailsRef){
      this.locationRelatedService.dialogDetailsRef.close();
    }
    if(this.locationRelatedService.dialogTicketRef){
      this.locationRelatedService.dialogTicketRef.close();
    }

    this.clearLayersMap();
  }

  getLocationsRelated(){
    this.suscription_getLocationRelatedList = this.locationRelatedService.GetAllByIdentifier(this.identifier, this.includeRoute).subscribe(data => {
      if (data.isSuccess) {
        this.getRelatedByIdentifierResponse =data.result;
        console.log(data.result);
        this.itemList = this.getRelatedByIdentifierResponse.listLocationRelated;
        this.originalShownLocationRelatedList = this.itemList;
        this.shownLocationRelatedList = this.itemList;

        if (this.shownLocationRelatedList.length == 0){
          this.locationRelatedListResponse = "No se encontaron activos asociados";
        }
        else{
          if (!this.includeRoute)
            return;
          
          this.updateLayersMap();
        }
    }
    });
  }

  updateLayersMap(){
    if (this.getRelatedByIdentifierResponse.routeGeoJSON != null && this.getRelatedByIdentifierResponse.routeGeoJSON != "") {
      this.mapHelperService.UpdateLayerGeoJson("routeLocationRelatedSource", JSON.parse(this.getRelatedByIdentifierResponse.routeGeoJSON));
      this.mapHelperService.FitBounds(JSON.parse(this.getRelatedByIdentifierResponse.routeGeoJSON).features[0].geometry);
    }

    if (this.getRelatedByIdentifierResponse.pointsGeoJSON != null && this.getRelatedByIdentifierResponse.pointsGeoJSON != "") {
      this.mapHelperService.UpdateLayerGeoJson("locationRelatedSource", JSON.parse(this.getRelatedByIdentifierResponse.pointsGeoJSON));
    }
  }

  clearLayersMap(){
    this.mapHelperService.UpdateLayerGeoJson("routeLocationRelatedSource", this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("locationRelatedSource", this.mapHelperService.Empty_GeoJson);
  }

  listPopUp(event){
    console.log("popUp engineer");
    this.notifyService.LocationsRelatedDetails(undefined);
  }

  clickService(locationRelated: LocationRelatedDTO): void {
    this.locationRelatedService.openRelatedDetailsPopup(locationRelated.identifierChild);
    // if (this.includeRoute) {
    //   this.locationRelatedService.openTicketPopup(locationRelated);
    // }else{
    //   this.locationRelatedService.openRelatedDetailsPopup(locationRelated.identifierChild);
    // }
  }

  

  filter(event) {
    this.locationRelatedService.isLoadingList = true;
    if (event.length > 0) {
      this.subscription_GetAllRelatedFilteredList.unsubscribe();
      this.subscription_GetAllRelatedFilteredList = this.locationRelatedService.GetRelatedFilteredByIdentifier( this.identifier, event, this.includeRoute).subscribe((data: any) => {
        if (data.isSuccess) {
          this.shownLocationRelatedList = data.result.listLocationRelated;

          if (this.shownLocationRelatedList.length == 0)
            this.locationRelatedListResponse = "No hay resultados de búsqueda";

        }
        this.locationRelatedService.isLoadingList = false;
      });
    } 
    else {
      this.subscription_GetAllRelatedFilteredList.unsubscribe();
      this.shownLocationRelatedList = this.itemList;
      this.itemsListPivot = [];
      this.locationRelatedService.isLoadingList = false;
    }
  }

  drop(event: CdkDragDrop<LocationRelatedDTO[]>) {
    moveItemInArray(this.shownLocationRelatedList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.shownLocationRelatedList.length; i++) {
      this.shownLocationRelatedList[i].noOrder = i + 1;
    }
    
  }

  refreshRelatedList(){
    this.shownLocationRelatedList = this.originalShownLocationRelatedList;
  }

  updateRelatedList(){
    this.notifyService.confirmMessage( "Actualizar lista de activos relacionados", "¿Está seguro de actualizar la lista de activos relacionados?").then((result) => {
      if (result.isConfirmed) {
        this.locationRelatedService.isLoadingList = true;
        this.suscription_updateLocationsRelated = this.locationRelatedService.UpdateLocationRelatedOrder(this.shownLocationRelatedList, this.identifier).subscribe((data: any) => {
          if (data.isSuccess) {
            this.notifyService.MessageSuccessful("Exito", "Lista de activos relacionados actualizada correctamente");
            this.getRelatedByIdentifierResponse = data.result;
            this.originalShownLocationRelatedList = this.shownLocationRelatedList;
            this.updateLayersMap();
          }else{
            this.notifyService.MessageError("Error al actualizar la lista de activos relacionados");
          }
          this.locationRelatedService.isLoadingList = false;
        });
      }
    });
  }

}
